import {type GenType, type ScreenSize} from '@features/flow/flowService';

export const NODE_SPACING = 200;

export const COMPONENT_NODE_OFFSET = 600;

export const ESTIMATED_COMPONENT_SIZE = 500;

export const getNodeDimensions = (genType: GenType | ScreenSize) => {
  const isMobile = genType !== 'components' && genType.includes('mobile');
  const width = isMobile ? 375 : 1440;
  return {
    width,
    height: isMobile ? 812 : 1024,
    offset: width + NODE_SPACING,
  };
};

export function withComponentDimensions<
  T extends {x: number | null; y: number | null; type: 'screen' | 'component'},
>(screens: T[]): Array<T & {width?: number; height?: number}> {
  return screens.map((s) =>
    s.type === 'component'
      ? {
          ...s,
          width: ESTIMATED_COMPONENT_SIZE,
          height: ESTIMATED_COMPONENT_SIZE,
        }
      : s,
  );
}
